// src/components/hub/work/ChartsSection.js
import React from "react";
import ThroughputChart from "./ThroughputChart";
import TimeInPositionChart from "./TimeInPositionChart";
import WaitingOnThemChart from "./WaitingOnThemChart";

const ChartsSection = ({
  canSeeCharts,
  showCharts,
  onToggle,
  chartsLoading,
  throughputData = [],
  positionData = [],
  waitingData = [],
  openDrill,
}) => {
  return (
    <>
      <div className="flex items-center justify-between">
        {canSeeCharts && (
          <button
            type="button"
            onClick={onToggle}
            className="flex items-center gap-2 text-sm font-medium text-gray-500 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 transition-colors"
          >
            <svg
              className={`w-4 h-4 transition-transform ${showCharts ? "rotate-90" : ""}`}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="9 18 15 12 9 6" />
            </svg>
            Charts
          </button>
        )}
      </div>

      {canSeeCharts && showCharts && (
        <div className="mt-4 space-y-4">
          {chartsLoading ? (
            <>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-stretch min-h-[400px]">
                <div className="bg-white dark:bg-gray-900 rounded-xl shadow border border-gray-200 dark:border-gray-800 p-5 animate-pulse">
                  <div className="h-4 w-40 bg-gray-200 dark:bg-gray-700 rounded mb-2" />
                  <div className="h-3 w-56 bg-gray-200 dark:bg-gray-700 rounded mb-4" />
                  <div className="h-48 bg-gray-100 dark:bg-gray-800 rounded-lg" />
                </div>
                <div className="bg-white dark:bg-gray-900 rounded-xl shadow border border-gray-200 dark:border-gray-800 p-5 animate-pulse">
                  <div className="h-4 w-40 bg-gray-200 dark:bg-gray-700 rounded mb-2" />
                  <div className="h-3 w-56 bg-gray-200 dark:bg-gray-700 rounded mb-4" />
                  <div className="h-48 bg-gray-100 dark:bg-gray-800 rounded-lg" />
                </div>
              </div>
              <div className="bg-white dark:bg-gray-900 rounded-xl shadow border border-gray-200 dark:border-gray-800 p-5 animate-pulse">
                <div className="h-4 w-40 bg-gray-200 dark:bg-gray-700 rounded mb-2" />
                <div className="h-3 w-56 bg-gray-200 dark:bg-gray-700 rounded mb-4" />
                <div className="h-[350px] bg-gray-100 dark:bg-gray-800 rounded-lg" />
              </div>
            </>
          ) : (
            <>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-stretch min-h-[400px]">
                <TimeInPositionChart data={positionData} openDrill={openDrill} />
                <WaitingOnThemChart data={waitingData} openDrill={openDrill} />
              </div>
              <ThroughputChart data={throughputData} openDrill={openDrill} />
            </>
          )}
        </div>
      )}
    </>
  );
};

export default ChartsSection;
